import React, { useRef } from 'react';

import { useSelector } from 'react-redux';
import { RootState } from 'redux/rootReducer';
import { ICustomer } from 'redux/reducers/customers';

import TableLoader from 'components/utility/ContentLoader/TableLoader/TableLoader';
import SearchField from 'components/styled/SearchField/SearchField';
import NoResults from 'components/utility/NoResults/NoResults';

import {
  TableHead,
  TableWrapper,
  TableBody,
  TH,
  Cell,
  SearchFieldWrapper,
  BoxPositionRelative,
} from '../../../FAQActivityTracker.styles';

import Row from './Row';

interface IPriorityTableProps {
  data?: any;
  isLoading?: boolean;
  isMobileView?: boolean;
  showNoResults?: boolean;
  searchInputValue: string;
  handleSearchInput: (evt: any) => void;
}

const PriorityTable: React.FC<IPriorityTableProps> = (props) => {
  const {
    data,
    isLoading,
    isMobileView,
    showNoResults,
    handleSearchInput,
    searchInputValue,
  } = props;
  const searchField = useRef();
  let height;
  if (isMobileView) {
    height =
      data?.length > 10 || isLoading ? '800px' : `${110 + data?.length * 71}px`;
  }
  const customers = useSelector((state: RootState) => state.customers.data);

  return (
    <BoxPositionRelative height={height}>
      <SearchFieldWrapper>
        <SearchField
          handleSearch={handleSearchInput}
          value={searchInputValue}
          placeholder={'Search Popular Playlists'}
          refObj={searchField}
        />
      </SearchFieldWrapper>
      {showNoResults && <NoResults searchValue={searchInputValue} />}
      {((data && data.length > 0) || isLoading) && !isMobileView && (
        <TableHead>
          <tr>
            <TH>playlist name</TH>
            <TH>DSP</TH>
          </tr>
        </TableHead>
      )}
      <TableWrapper>
        <TableBody>
          {data?.length > 0 && customers && !isLoading ? (
            <>
              {data.map((row: any, index: number): JSX.Element | null => {
                const key = `priorityTable-${row.id}-${index}`;
                const currentCustomer = customers.filter(
                  (customer: ICustomer) =>
                    customer.id === row.customerId &&
                    customer.feedType === 'streaming'
                );
                const customerName =
                  (currentCustomer.length > 0 &&
                    currentCustomer[0].displayName) ||
                  '';

                return <Row key={key} {...row} customerName={customerName} />;
              })}
            </>
          ) : (
            !showNoResults && (
              <TableLoader columnCount={2} rowCount={10} cellComponent={Cell} />
            )
          )}
        </TableBody>
      </TableWrapper>
    </BoxPositionRelative>
  );
};

export default PriorityTable;
